import { noop } from 'utils'
import { useDispatch } from 'react-redux'
import { Dialogs } from './dialogSlice'
import Dialog from './Dialog'
import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import {
  getLastDialogIndex,
  useCreateDialogHook,
} from 'features/dialog/dialogHookFactory'
import NoneAnchor from 'components/NoneAnchor'

const Confirm = memo(
  ({
    id,
    title,
    onOpen = noop,
    onClose = noop,
    confirmText = '확인',
    cancelText = '취소',
    children,
    changeLayoutClass = true,
  }) => {
    const dispatch = useDispatch()
    const close = isConfirmed => () => {
      onClose({ isConfirmed })
      dispatch(Dialogs.hide(id))
    }

    return (
      <Dialog
        id={id}
        onOpen={onOpen}
        onClose={onClose}
        changeLayoutClass={changeLayoutClass}>
        {title && <strong className="tit_layer">{title}</strong>}
        <p className="txt_layer">{children}</p>
        <div className="btn_group">
          <NoneAnchor onClick={close(false)} className="btn_gm">
            <span className="inner_g">{cancelText}</span>
          </NoneAnchor>
          <NoneAnchor onClick={close(true)} className="btn_gm gm_bl">
            <span className="inner_g">{confirmText}</span>
          </NoneAnchor>
        </div>
      </Dialog>
    )
  }
)

Confirm.displayName = 'Confirm'
Confirm.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  title: PropTypes.string,
  cancelText: PropTypes.node,
  confirmText: PropTypes.node,
  changeLayoutClass: PropTypes.bool,
}

export const useConfirm = (changeLayoutClass = true) =>
  useCreateDialogHook(
    Confirm,
    useMemo(() => getLastDialogIndex(), []),
    changeLayoutClass
  )
